module.exports = __webpack_public_path__ + "static/media/ng.ba3bb51a.svg";